//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    recommend: {
      type: Array
    }
  },
  data: function data() {
    return {
      currentIndex: 0,
      teachers: []
    };
  },
  computed: {
    currentTeacher: function currentTeacher() {
      return this.teachers[this.currentIndex];
    }
  },
  created: function created() {
    // 确保有足够的讲师数据用于滚动展示
    console.log(666, this.recommend);
    this.teachers = this.recommend.map(function (item) {
      return {
        id: item.teacher_id,
        name: item.teacher_name,
        description: item.introduction,
        title: item.marketing_language,
        imageUrl: item.photo,
        avatar: item.teacher_avatar
      };
    });
    console.log(445, this.teachers);
  },
  methods: {
    nextTeacher: function nextTeacher() {
      this.currentIndex = (this.currentIndex + 1) % this.teachers.length; // 确保切换后也能正确滚动

      this.scrollToActiveTeacher();
    },
    prevTeacher: function prevTeacher() {
      this.currentIndex = (this.currentIndex - 1 + this.teachers.length) % this.teachers.length; // 确保切换后也能正确滚动

      this.scrollToActiveTeacher();
    },
    switchTeacher: function switchTeacher(index) {
      this.currentIndex = index;
      this.scrollToActiveTeacher();
    },
    // 提取为单独的滚动方法，方便复用
    scrollToActiveTeacher: function scrollToActiveTeacher() {
      var _this = this;

      this.$nextTick(function () {
        var container = _this.$refs.teacherItemsContainer;
        if (!container || !container.children.length) return; // 使用更可靠的方式获取当前激活的讲师项

        var activeTeacherItem = container.querySelector(".teacher-item.active");
        var firstTeacherItem = container.children[0];

        if (_this.currentIndex === 0 && firstTeacherItem) {
          // 如果是第一个讲师，强制滚动到顶部
          container.scrollTop = 0;
          console.log('滚动到顶部');
        } else if (activeTeacherItem) {
          // 对于其他讲师，计算并滚动到适当位置
          var containerRect = container.getBoundingClientRect();
          var itemRect = activeTeacherItem.getBoundingClientRect(); // 计算滚动偏移量，确保选中项在视图中间

          var scrollOffset = itemRect.top - containerRect.top - containerRect.height / 2 + itemRect.height / 2;
          container.scrollTop += scrollOffset;
          console.log('滚动到选中项，偏移量:', scrollOffset);
        }
      });
    },
    handleEnter: function handleEnter() {
      clearInterval(this.autoPlayInterval);
    },
    handleLeave: function handleLeave() {
      this.autoPlay();
    },
    autoPlay: function autoPlay() {
      var _this2 = this;

      // 自动轮播
      this.autoPlayInterval = setInterval(function () {
        _this2.nextTeacher();
      }, 5000);
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.autoPlay(); // 初始化时确保第一个讲师可见

    this.$nextTick(function () {
      _this3.scrollToActiveTeacher();
    });
  },
  beforeDestroy: function beforeDestroy() {
    // 清除自动轮播定时器
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
    }
  }
};